import { createSlice } from '@reduxjs/toolkit'
import { startListening } from '../listenerMiddleware';
import { getPerfil, putPerfil, putPerfilVendedorPadrao } from '../../services/meuPerfil';

const initialState = {
    info: undefined,
    sellerDefault: undefined,
    updated: false,
    loading: false,
    errors: [],
}

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        profileLoaded(state, action) {
            state.info = undefined,
            state.sellerDefault = undefined,
            state.loading = true,
            state.errors = []
        },
        profileSuccess(state, action) {
            const { payload } = action;
            state.info = payload?.info ?? state.info,
            state.sellerDefault = payload?.sellerDefault ?? state.sellerDefault,
            state.loading = false,
            state.errors = []
        },
        profileError(state, action) {
            const {payload} = action;
            state.info = undefined,
            state.sellerDefault = undefined,
            state.loading = false,
            state.errors = payload.messages
        },
        profileUpdate(state, action) {
            const {payload} = action;
            state.info = payload ?? state.info,
            state.sellerDefault = payload?.sellerDefault ?? state.sellerDefault,
            state.loading = true,
            state.updated = false,
            state.errors = []
        },
        profileUpdateDefaultSeller(state, action) {
            const {payload} = action;
            state.info = payload?.info ?? state.info,
            state.sellerDefault = payload ?? state.sellerDefault,
            state.loading = true,
            state.updated = false,
            state.errors = []
        },
        profileUpdated(state,action) {
            state.loading = false,
            state.updated = true,
            state.errors = []
        }
    }
})

export const {
    profileLoaded,
    profileSuccess,
    profileError,
    profileUpdate,
    profileUpdateDefaultSeller,
    profileUpdated
} = profileSlice.actions;

export default profileSlice.reducer;

startListening({
    actionCreator: profileUpdated,
    effect: async (action, listenerApi) => {
        try {
            const response = await consultarInformacoesAsync();
            listenerApi.dispatch(profileSuccess(response));
        } catch (error) {
            listenerApi.dispatch(profileError(error.messages));
        }
    },
})

startListening({
    actionCreator: profileLoaded,
    effect: async (action, listenerApi) => {
        try {
            const response = await consultarInformacoesAsync();
            listenerApi.dispatch(profileSuccess(response));
        } catch (error) {
            listenerApi.dispatch(profileError(error.messages));
        }
    },
})


startListening({
    actionCreator: profileUpdate,
    effect: async (action, listenerApi) => {
        try {           
            await putPerfil(action.payload);
            listenerApi.dispatch(profileUpdated());
        } catch (error) {
            listenerApi.dispatch(profileError(error.messages));
        }
    },
})

startListening({
    actionCreator: profileUpdateDefaultSeller,
    effect: async (action, listenerApi) => {
        try {
            const {payload: codigoCorretor} = action;
            await putPerfilVendedorPadrao(codigoCorretor);
            listenerApi.dispatch(profileSuccess({sellerDefault:codigoCorretor}));
        } catch ({messages}) {
            listenerApi.dispatch(profileError(messages));
        }
    },
})


const consultarInformacoesAsync = async () =>
    getPerfil()
        .then(({ data }) => {
            const { vendedores = [] } = data;
            if (vendedores.length === 0)
                return { info: data };
            const { codigoCorretor } = vendedores.find(x => x?.perfilPadrao) ?? {};
            return { info: data, sellerDefault: codigoCorretor };
        });

